import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';
import { Hostel } from '@app/services/api/api.service';

@Component({
  selector: 'app-contact-hostel',
  templateUrl: './contact-hostel.component.html',
  styleUrls: ['./contact-hostel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('fadeIn', [
      transition(':enter', [
        style({ transform: 'translateY(-8px)', opacity: 0.4 }),
        animate(
          '0.15s ease-in',
          style({ transform: 'translateY(0)', opacity: 1 })
        ),
      ]),
    ]),
  ],
})
export class ContactHostelComponent {
  @Input()
  public hostel?: Hostel;
}
